import * as React from 'react'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import ActionButton from '../../ui/ActionButton/ActionButton'

import media from '../../../services/generateMediaQueries'

import RedeemSuccessImage from '../../../assets/img/redeem-success.png'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('xsmall')`
    border-radius: 0;
    max-width: unset;
  `}
`

const ModalContentWrapper = styled.div`
  overflow: auto;
  max-height: 100vh;
  width: 100%;
`

const ModalContent = styled.div`
  position: relative;
  padding: 2rem;
  margin: 3rem auto;
  width: 350px;
  min-height: 400px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;

  ${media.lessThan('small')`
    margin: 0;
    height: 100%;
    width: 100%;
    border-radius: 0;
  `}
`

const ModalImage = styled.img.attrs({ src: RedeemSuccessImage })`
  display: block;
  margin: 0 auto;
  margin-bottom: 2.375rem;
  width: 12rem;
`

const Title = styled.h2`
  color: var(--color-primary);
  font-size: 1.375rem;
  font-weight: var(--font-weight-bold);
  text-align: center;
  margin: 0;
  margin-bottom: 0.625rem;
`

const Description = styled.p`
  color: var(--color-primary);
  font-size: 0.875rem;
  line-height: 1.375rem;
  text-align: center;
  margin: 0;
  margin-bottom: 1.5rem;
`

const BlockActionButton = styled(ActionButton)`
  margin-top: 1rem;
  width: 100%;
`

const overlay = {
  zIndex: 10005,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function RedeemSuccessModal(props) {
  const { show, onViewVoucher, onViewWallet } = props

  return (
    <StyledReactModal
      isOpen={show}
      style={{ overlay, content }}
      closeTimeoutMS={150}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
    >
      <ModalContentWrapper>
        <ModalContent>
          <ModalImage />
          <Title>Yay, you just redeemed a new voucher!</Title>
          <Description>
            Zing your way to your reward by clicking on the voucher inside your
            wallet.
          </Description>
          <BlockActionButton variant="primary" onClick={onViewVoucher}>
            View voucher
          </BlockActionButton>
          <BlockActionButton onClick={onViewWallet}>
            Back to voucher wallet
          </BlockActionButton>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

RedeemSuccessModal.defaultProps = {}

RedeemSuccessModal.propTypes = {
  // TODO: specify prop types
}

export default RedeemSuccessModal
